import { render, staticRenderFns } from "./PaymentSidebar.vue?vue&type=template&id=f4c7ff60&scoped=true&"
import script from "./PaymentSidebar.vue?vue&type=script&lang=js&"
export * from "./PaymentSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c7ff60",
  null
  
)

export default component.exports